import { __awaiter } from 'tslib';
import React from 'react';
import ReactDOM from 'react-dom';
import { isAndroid } from '@tencent/docs-user-agent/pure';
import MobileMenu from './mobile-menu.js';
import './style/index.less.js';
export { MobileMenuState } from './mobile-menu.interface.js';

const ID = 'mobile-design-menu-mountpoint';
const mobileMenu = {};
/**
 * 显示一个半屏菜单，支持重复调用 show 来更新菜单内容。
 * @param props - 菜单参数
 * @param id - 菜单容器 id
 * @public
 */
const showMenu = (props_1, ...args_1) => __awaiter(void 0, [props_1, ...args_1], void 0, function* (props, id = ID) {
    var _a;
    let container = document.getElementById(id);
    const { clickMaskDestoryPanel = true } = props;
    if (container && ((_a = mobileMenu[id]) === null || _a === void 0 ? void 0 : _a.instance) && (!mobileMenu[id].destory && !clickMaskDestoryPanel)) {
        // 当默认点击蒙层关闭 且 调用 hideMenu 时 destory 没有传false 才直接显示菜单
        container.style.display = 'block';
        mobileMenu[id].instance.showPanel();
        return;
    }
    if (!container) {
        container = document.createElement('div');
        container.id = id;
        document.body.appendChild(container);
    }
    const isHasSafeAreaInsetBottom = yield hasSafeAreaInsetBottom();
    container.style.display = 'block';
    ReactDOM.render(React.createElement(MobileMenu, Object.assign({ ref: ref => (mobileMenu[id] = { instance: ref, destory: clickMaskDestoryPanel }) }, props, { clickMaskDestoryPanel: clickMaskDestoryPanel, hasSafeAreaInsetBottom: isHasSafeAreaInsetBottom })), container);
    document.dispatchEvent(new CustomEvent('MobileMenuStateChanged', {
        detail: { isHide: false },
    }));
});
/**
 * 隐藏半屏面板
 * @param immediately - 是否立即隐藏，如果为 false，会有动画效果
 * @param id - 菜单容器 id
 * @param destory - 是否销毁面板
 * @public
 */
const hideMenu = (immediately = true, id = ID, destory = true) => {
    var _a;
    const container = window.document.getElementById(id);
    mobileMenu[id] = Object.assign(Object.assign({}, mobileMenu[id]), { destory });
    if (container) {
        if (immediately) {
            container.style.display = 'none';
        }
        // 只是把容器隐藏还不行，会导致下一次打开状态出错
        // 这里还需要调用内部接口，真正的把 panel 的状态也给设置成隐藏
        if ((_a = mobileMenu[id]) === null || _a === void 0 ? void 0 : _a.instance) {
            mobileMenu[id].instance.hidePanel(destory);
        }
    }
};
/**
 * 获取当前菜单实例
 * 可用于直接访问到 menu 实例做 forceUpdate
 * @public
 */
const getMenuRef = (id = ID) => { var _a; return (_a = mobileMenu[id]) === null || _a === void 0 ? void 0 : _a.instance; };
/**
 * 当前菜单是否显示
 * @public
 */
const isShown = (id = ID) => { var _a, _b; return !!((_b = (_a = mobileMenu[id]) === null || _a === void 0 ? void 0 : _a.instance) === null || _b === void 0 ? void 0 : _b.isShown()); };
/**
 * 通过 api 获取底部状态
 */
const getNavigationBarStatus = () => new Promise((resolve) => {
    var _a;
    try {
        (_a = window === null || window === void 0 ? void 0 : window.mqq) === null || _a === void 0 ? void 0 : _a.invoke('docx', 'getNavigationBarStatus', {}, (res) => {
            resolve({ res: ((res === null || res === void 0 ? void 0 : res.navigationMode) === 2 && (res === null || res === void 0 ? void 0 : res.showGestureBar)) });
        });
    }
    catch (err) {
        console.error(err);
        resolve({ res: false });
    }
    // 无法捕获js bridge错误，默认返回结果，不阻塞后续执行
    setTimeout(() => resolve({ res: false }), 150);
});
/**
 * 是否有底部安全区域
 */
const hasSafeAreaInsetBottom = () => __awaiter(void 0, void 0, void 0, function* () {
    let result = false;
    try {
        const { res } = yield getNavigationBarStatus();
        result = res;
    }
    catch (err) {
        console.error(err);
    }
    // ios通过JS API 判断没有再通过其他方式判断
    if (!result && !isAndroid()) {
        const element = document.createElement('div');
        element.style.bottom = 'calc(env(safe-area-inset-bottom))';
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        document.body.appendChild(element);
        const computedStyle = window.getComputedStyle(element);
        const bottom = computedStyle.bottom;
        document.body.removeChild(element);
        // 通过给临时元素设置 env(safe-area-inset-bottom) 判断是否有底部安全区域
        result = bottom !== '0px';
    }
    return result;
});

export { MobileMenu as default, getMenuRef, hideMenu, isShown, showMenu };
//# sourceMappingURL=index.js.map
